import React from 'react';
import styles from './day-calendar.module.scss';

interface MicroSlotProps {
  index: number;
  microSlotHeight: number;
  isFullyOutside: boolean;
  isLast: boolean;
  gradientStyle: React.CSSProperties;
  onClick: () => void;
}

export const MicroSlot: React.FC<MicroSlotProps> = ({
  index,
  microSlotHeight,
  isFullyOutside,
  isLast,
  gradientStyle,
  onClick,
}) => {
  return (
    <div
      className={`${styles.time_slot__microslot} ${
        isFullyOutside ? styles.time_slot__microslot_outside_work : ''
      }`}
      style={{
        top: `${index * microSlotHeight}px`,
        height: `${microSlotHeight}px`,
        ...(isLast ? { borderBottom: 'none' } : {}),
        ...gradientStyle,
      }}
      onClick={onClick}
    />
  );
};
